import { render } from "./TableHome.vue?vue&type=template&id=00eb9ba5"
import script from "./TableHome.vue?vue&type=script&lang=js"
export * from "./TableHome.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__